export default "__VITE_ASSET__ClEfyDKZ__"